var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper w-100"},[_c('Breadcrumb',{attrs:{"breadcrumbOptions":_vm.breadcrumbData}}),(_vm.getData.policy != '')?_c('div',{staticClass:"privacy_policy_page_wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"page_content",domProps:{"innerHTML":_vm._s(_vm.getData.policy)}})])]):_c('EmptyContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }